const alphabets = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
];

const Animals = [
    { "name": "ant", "image": "/Animals/Ant.png", "audio":"/music/ant_speech.mp3"},
    // { "name": "bat", "image": "/Animals/Bat.png" },
    { "name": "alligator", "image": "/Animals/alligator.png","audio":"/music/Alligator_speech.mp3" },
    { "name": "apple", "image": "/Others/Apple.png","audio":"/music/Apple_speech.mp3" },
    // { "name": "rat", "image": "/Animals/Rat.png" },
    // { "name": "cat", "image": "/Animals/Cat.png" },
]
  
  
export { alphabets, Animals }